export default "__VITE_ASSET__f712ff0a__"